/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

/*
 * Ticket description.  Should have these behaviors
 *
 * o A blue background and an 'x' to clear when there are multiple values
 *
 * o A red background and an exclamation point (clickable for popup) when
 *   there is a validation error.
 *
 * API convention:
 *
 * This component is meant to be embedded in a parent component that has
 * a parent form.  It's expected that the parent passes it's FormGroup
 * reference in as an Input to this component.  Further, the parent must
 * also configure the form control as part of creating the form group,
 * specicifically referring to this component with the name "description",
 * and supplying a required validator.  The parent can optionally supply an
 * initial text value too.
 *
 */

import {
	Input,
	Component,
	ChangeDetectionStrategy,
	Self,
	Optional,
	ChangeDetectorRef,
	OnInit,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { MultiWrapperComponent } from '../multi-wrapper/multi-wrapper.component';
import { takeUntil } from 'rxjs/operators';

import { TicketEditBaseComponent } from '../ticket-edit-base/ticket-edit-base.component';
import { TicketEditService } from 'src/app/modules/ticket-edit/ticket-edit.service';
import { cleanWhiteSpace } from '@touchplan/common';

@Component({
	selector: 'ticket-description',
	templateUrl: './ticket-description.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TicketDescriptionComponent extends TicketEditBaseComponent implements OnInit {
	@Input() public shouldFocus = false;

	constructor(
		@Self() @Optional() public control: NgControl,
		@Optional() public multiWrapper: MultiWrapperComponent,
		@Optional() protected cd: ChangeDetectorRef,
		private ticketEditService: TicketEditService
	) {
		super(control, multiWrapper, cd);
	}

	public ngOnInit() {
		super.ngOnInit();
		this.internalField.valueChanges.pipe(takeUntil(this.shutdownSubject)).subscribe((val) => {
			this.onChange(cleanWhiteSpace(val));
		});
	}
}
